import React from 'react';
import { LanguageContext } from "../context/LanguageContext";

export const useTranslation = () => {
  const context = React.useContext(LanguageContext);
  if (!context) {
    throw new Error("useTranslation must be used within a LanguageProvider");
  }

  //  FIXED: Use the t function directly from context
  const { language, t } = context;

  return { t, language };
};
